const LoginButtonWidth = 300;

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 100px)',
        '@media(max-width:768px)': {
            height: 'calc(100vh - 70px)'
        }
    },
    loginContent: {
        marginTop: '89px !important',
        '@media (max-width:767px)': {
            marginTop: '17px !important',
        }
    },
    panel: {
        width: LoginButtonWidth,
        margin: `${theme.spacing(1)}px auto`,
    },
    scanButton: {
        display: 'inline-block',
        paddingTop: 10,
        marginBottom: theme.spacing(3),
    },
    gunIcon: {
        stroke: theme.palette.primary.contrastText,
    },
    loginBar: {
        background: theme.palette.background.paper,
        borderBottom: `solid 3px ${theme.palette.primary.main}`,
    },
    loginContainer: {
        '@media (max-width: 340px)': {
            marginTop: theme.spacing(5)
        }
    },
    grow: {
        flexGrow: 1,
    },
    loginBarText: {
        color: theme.palette.text.secondary,
        fontWeight: 300,
        padding: theme.spacing(2),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: 54,
        '@media (max-width:375px)': {
            fontSize: 32
        }
    },
    hero: {
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
        height: 300,
        display: 'block',
        maxWidth: '100%',
        marginBottom: theme.spacing(1),
        '@media (max-width: 340px)': {
            display: 'none'
        }
    },
    loginIcon: {
        marginRight: theme.spacing(1)
    },
    logo: {
        maxHeight: 150
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        borderTop: `solid 1px ${theme.palette.common.border}`
    },
    footerUl: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    firstWord: {
        color: theme.palette.secondary.main
    }
});

export default styles;